import { SidePaneTabId } from '@web-app/components/CallV2/sidePaneTabIds';
import { molecule } from 'bunshi';
import { atom } from 'jotai';

import { SessionScope } from '../scopes';

/**
 * Side Pane Molecule
 *
 * Provides the active side pane tab state scoped to a session.
 * Defaults to the Prep tab.
 */
export const sidePaneMolecule = molecule((_, scope) => {
  scope(SessionScope);

  const activeSidePaneTabAtom = atom<SidePaneTabId>(SidePaneTabId.PREP);

  return { activeSidePaneTabAtom };
});
